import ScaleCard from './ScaleCard';

export default ScaleCard;
